import React, { useState, useEffect, useRef, useContext } from 'react';
import { classNames } from 'primereact/utils';
import { Route, Routes, useLocation } from 'react-router-dom';
import AppTopbar from './layouts/AppTopbar';
import AppFooter from './layouts/AppFooter';
import AppMenu from './layouts/AppMenu';
import Dashboard from './pages/dashboard/Dashboard';
import { Tooltip } from 'primereact/tooltip';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';

import { ChangePassword } from './pages/profile/changePassword';
import { RoleMaster } from './pages/UserManagement/RoleMaster/RoleMaster';
import { Users } from './pages/UserManagement/Users/Users';
import { InwardList } from './pages/UserManagement/Inward/InwardList';
import { InventoryList } from './pages/Inventory/InventoryList';
import { Parties } from './pages/Parties/Parties';
import { DispatchList } from './pages/Dispatch/DispatchList';
import { CreateDispatch } from './pages/Dispatch/CreateDispatch';

const App = (props: any) => {
    const [menuMode] = useState('slim');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [sidebarStatic, setSidebarStatic] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [sidebarActive, setSidebarActive] = useState(false);
    const [pinActive, setPinActive] = useState(false);
    const [activeInlineProfile, setActiveInlineProfile] = useState(false);
    const [resetActiveIndex, setResetActiveIndex] = useState<boolean>(false);
    const copyTooltipRef = useRef<any>();
    const location = useLocation();
    const [assignedActions, setAssignedActions] = useState<any>([]);

    // use effect method
    useEffect(() => {
        // getUserDetails();
    }, []);

    // //userDetail
    // const getUserDetails = async () => {
    //     const response = localStorage.getItem("permissions");
    //     console.log(response)
    //     if (response) {
    //         let tempAssignedActions = response.split(',');
    //         setAssignedActions(tempAssignedActions);
    //         assignedMenu(tempAssignedActions);
    //     }
    // };

    const menu = [
        {
            label: 'Dashboard',
            icon: 'pi pi-home',
            to: '/dashboard'
        },
        {
            label: 'User Management',
            icon: 'pi pi-spin pi-cog',
            to: '/users'
        },
        {
            label: 'Inward',
            icon: 'pi pi-box',
            to: '/inward-list'
        },
        {
            label: 'Inventory',
            icon: 'pi pi-list',
            to: '/inventory-list'
        },
        {
            label: 'Parties',
            icon: 'pi pi-users',
            to: '/parties'
        },
        {
            label: 'Dispatch',
            icon: 'pi pi-truck',
            to: '/dispatch-list'
        }
    ];

    // Make roles menu
    const assignedMenu = (assignedActions: any) => {
        let newMenu: any = menu;
        if (!window.cn(assignedActions)) {
            //check for assigned roles
            for (let i = 0; i < assignedActions.length; i++) {
                for (let j = 0; j < newMenu.length; j++) {
                    //check if inner roles exists
                    if (newMenu[j].hasOwnProperty('items')) {
                        let items: any = newMenu[j].items;
                        //check for inner roles
                        for (let k = 0; k < items.length; k++) {
                            //if role is assigned change status to 1
                            if (items[k].label == assignedActions[i]) {
                                items[k].status = '1';
                            }
                        }
                    } else {
                        //if role is assigned change status to 1
                        if (newMenu[j].label == assignedActions[i]) {
                            newMenu[j]['status'] = '1';
                        }
                    }
                }
            }

            //Create new array for assisgned roles to display in sidebar
            let newAssignedRoles = [];
            for (let j = 0; j < newMenu.length; j++) {
                if (newMenu[j].hasOwnProperty('items')) {
                    //check for inner roles
                    let items: any = newMenu[j].items;
                    for (let k = 0; k < items.length; k++) {
                        if (items[k]['status'] != undefined) {
                            //check if value exists in array of object or not
                            let valueExists = newAssignedRoles.some((el: any) => el.label == newMenu[j]['label']);
                            //if value exists in array of object the push in items array
                            if (valueExists) {
                                for (let x = 0; x < newAssignedRoles.length; x++) {
                                    if (newAssignedRoles[x]['label'] == newMenu[j]['label']) {
                                        newAssignedRoles[x]['items']?.push(items[k]);
                                    }
                                }
                            } else {
                                //if value does not exusts in array object then push new object in array
                                newAssignedRoles.push({
                                    label: newMenu[j]['label'],
                                    icon: newMenu[j]['icon'],
                                    items: [items[k]]
                                });
                            }
                        }
                    }
                } else {
                    if (newMenu[j]['status'] != undefined) {
                        newAssignedRoles.push(newMenu[j]);
                    }
                }
            }
            setAssignedActions(newAssignedRoles);
        }
    };

    let menuClick: any;

    let topbarItemClick: any;

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    useEffect(() => {
        setResetActiveIndex(true);
        setMenuActive(false);
    }, [menuMode]);

    const onDocumentClick = () => {
        if (!topbarItemClick) {
            setTopbarMenuActive(false);
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
                setResetActiveIndex(true);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                setOverlayMenuActive(false);
                setStaticMenuMobileActive(false);
            }

            hideOverlayMenu();
            unblockBodyScroll();
        }

        topbarItemClick = false;
        menuClick = false;
    };

    const onMenuButtonClick = (event: any) => {
        menuClick = true;

        if (isOverlay()) {
            setOverlayMenuActive((prevState) => !prevState);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive((prevState) => !prevState);
        } else {
            setStaticMenuMobileActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const onTopbarItemClick = (event: any) => {
        topbarItemClick = true;
        setTopbarMenuActive((prevState) => !prevState);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onToggleMenu = (event: any) => {
        menuClick = true;

        if (overlayMenuActive) {
            setOverlayMenuActive(false);
        }

        if (sidebarActive) {
            setSidebarStatic((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarMouseOver = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setSidebarActive(isDesktop());
            setTimeout(() => {
                setPinActive(isDesktop());
            }, 200);
        }
    };

    const onSidebarMouseLeave = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setTimeout(() => {
                setSidebarActive(false);
                setPinActive(false);
            }, 250);
        }
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onChangeActiveInlineMenu = (event: any) => {
        setActiveInlineProfile((prevState) => !prevState);
        event.preventDefault();
    };

    const onRootMenuItemClick = () => {
        setMenuActive((prevState) => !prevState);
    };

    const onMenuItemClick = (event: any) => {
        if (!event.item.items) {
            hideOverlayMenu();
            setResetActiveIndex(true);
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isOverlay = () => {
        return menuMode === 'overlay';
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const layoutClassName = classNames('layout-wrapper', {
        'layout-static': menuMode === 'static',
        'layout-overlay': menuMode === 'overlay',
        'layout-overlay-active': overlayMenuActive,
        'layout-slim': menuMode === 'slim',
        'layout-horizontal': menuMode === 'horizontal',
        'layout-active': menuActive,
        'layout-mobile-active': staticMenuMobileActive,
        'layout-sidebar': menuMode === 'sidebar',
        'layout-sidebar-static': menuMode === 'sidebar' && sidebarStatic,
        'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static'
    });

    return (
        <div className={layoutClassName} onClick={onDocumentClick}>
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

            <AppTopbar
                items={menu}
                // menuMode={menuMode}
                // menuActive={menuActive}
                topbarMenuActive={topbarMenuActive}
                activeInlineProfile={activeInlineProfile}
                onTopbarItemClick={onTopbarItemClick}
                // onMenuButtonClick={onMenuButtonClick}
                // onSidebarMouseOver={onSidebarMouseOver}
                // onSidebarMouseLeave={onSidebarMouseLeave}
                // onToggleMenu={onToggleMenu}
                // onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                // onMenuClick={onMenuClick}
                // onMenuItemClick={onMenuItemClick}
                // onRootMenuItemClick={onRootMenuItemClick}
                // resetActiveIndex={resetActiveIndex}
            />

            <AppMenu
                model={localStorage.getItem('user_type') === 'Admin' ? menu : assignedActions}
                onRootMenuItemClick={onRootMenuItemClick}
                onMenuItemClick={onMenuItemClick}
                onToggleMenu={onToggleMenu}
                onMenuClick={onMenuClick}
                menuMode={menuMode}
                menuActive={menuActive}
                sidebarActive={sidebarActive}
                sidebarStatic={sidebarStatic}
                pinActive={pinActive}
                onSidebarMouseLeave={onSidebarMouseLeave}
                onSidebarMouseOver={onSidebarMouseOver}
                activeInlineProfile={activeInlineProfile}
                onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                resetActiveIndex={resetActiveIndex}
            />
            <div className="layout-main">
                <div className="layout-main-content">
                    <Routes>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/change-password" element={<ChangePassword />} />

                        {/* Users */}
                        <Route path="/users" element={<Users />} />

                        {/* Inward List */}
                        <Route path="/inward-list" element={<InwardList />} />

                        {/* Inventory List */}
                        <Route path="/inventory-list" element={<InventoryList />} />

                        {/* Parties */}
                        <Route path="/parties" element={<Parties />} />

                        {/* Dispatch List */}
                        <Route path="/dispatch-list" element={<DispatchList />} />
                        <Route path="/create-dispatch" element={<CreateDispatch />} />
                    </Routes>
                </div>

                <AppFooter />
            </div>
        </div>
    );
};

export default App;
